import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ModalController } from '@ionic/angular';
import { ModalDisplayComponent } from 'src/app/shared/components/modal-display/modal-display.component';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

export interface ICheckoutTermsAgreementForm {
  agreement: boolean;
}

@Component({
    selector: 'store-checkout-terms-agreement-form',
    templateUrl: './checkout-terms-agreement-form.component.html',
    styleUrls: ['./checkout-terms-agreement-form.component.scss'],
    standalone: false
})
export class CheckoutTermsAgreementFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  @Output()
  onSubmit: EventEmitter<ICheckoutTermsAgreementForm> = new EventEmitter<ICheckoutTermsAgreementForm>();

  constructor(private fb: FormBuilder,
    public settingService: SettingService,
    //private translateService: TranslateService,
    private modalCtrl: ModalController,
    private loader: LoaderService,
    public validators: ValidatorsService,
    private translationService: TranslationService) {

  }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'terms': [false, this.validators.formBuilderValidationInitializer(true)]
    });
    */
    this.form = this.fb.group({
      terms: this.fb.control(false, {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      terms: null
    };
    */
    this.patternReference = {
      terms: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);

   //this.settingService.configuration.name
  }

  get merchantName() {
    return this.settingService.configuration.subdomain.replace(/\s/g, "");
  }

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));


    if (!this.form.valid) {
      this.onSubmit.emit(null);
      return;
    }

    this.formErrors.clear();

    this.onSubmit.emit({
      agreement: this.form.get("terms").value
    });
  }

  async showTerms() {
    //Fetch terms to SMA/Import them when importing the brand and query us
    const loader = await this.loader.create();
    await loader.present();
    this.settingService.getSATerms(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Terms",
            content: terms
          }
        });

        await requestModal.present();
      });
  }

  async showPolicies() {
    //Show SHOPACHAT policies
    const loader = await this.loader.create();
    await loader.present();
    this.settingService.getSAPolicies(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Policies",
            content: terms
          }
        });

        await requestModal.present();
      });
  }
}
